import React, { useEffect } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import HeaderPartner from "./HeaderPartner";
import sheild from "../asset/images/revamp-images/shieldImg.svg";
import { Link } from "react-router-dom";
import { useState } from "react";
import PageProgressBarPartner from "./PageProgressBarPartner";
import { useNavigate } from "react-router-dom";
import { Partner_Portal } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import SmallLoader from "../Components/Common/smallLoader";
import {
  decryptData,
  encryptData,
  validateIFSC,
} from "../CommonMethods/CommonMethods";
import axios from "axios";
import previosPageArrow from "../asset/images/revamp-images/previousPageBtn.svg";
import FormFooterPartner from "./FormFooterPartner";
import PageSideBar from "./PageSideBar";
import { professionList } from "../CommonMethods/ProfessionList";
import DigiDocumentList from "./DigiDocumentList";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";


const BankDetailsPartner = () => {
  const partnerToken = localStorage.getItem("partner_signup_token");
  // const loginToken = localStorage.getItem("Partner_Login_Token");
  const manualselect = localStorage.getItem("manualUpload");
  const showBankData = localStorage.getItem("showBankData");
  const [bankLoader, setBankLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selectBank, setSelectBank] = useState("");
  const [selectBranch, setSelectBranch] = useState("");
  const [bankError, setBankError] = useState("");
  const [branchError, setBranchError] = useState("");
  const [bankDataList, setBankDataList] = useState("");
  const [bankShow, setBankShow] = useState(false);
  const [bankName, setBankName] = useState("");
  const [branchIfscData, setBranchIfscData] = useState("");
  const [branchName, setBranchName] = useState("");
  const [branchShow, setBranchShow] = useState(false);
  const [bankList, setBankList] = useState();
  const [branchList, setBranchList] = useState();
  const [impsLoader, setImpsLoader] = useState(false);
  const [impsSuccess, setImpsSuccess] = useState(false);
  const [impsValue, setImpsValue] = useState();
  const [showBankDetails, setShowBankDetails] = useState(false);
  const navigate = useNavigate();
  const [initialBankData, setInitialBankData] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [digilockerStatus, setDigilockerStatus] = useState(false);
  const [partnerData, setPartnerData] = useState("")

  if (partnerToken == null) {
    window.location.replace("/partner");
  }

  const schema = Yup.object().shape({
    accountNum: Yup.string()
      .required("Enter Account Number")
      .min(9, "Bank account number should be at least 9 digit")
      .matches(/^[0-9]+$/, "Numbers only"),

    reAccountNum: Yup.string()
      .required("Confirm Bank Account Number")
      .min(9, "Bank account number should be at least 9 digit")
      .oneOf([Yup.ref("accountNum")], "Bank account numbers should be same"),

    accType: Yup.string().required("Account type is required"),

    ifscCode: Yup.string()
      .required("IFSC Code is required")
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter valid IFSC Code"),

    profession: Yup.string().required("Profession is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    clearErrors,
    trigger,
    setError,
    getValues,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      accountNum: "",
      reAccountNum: "",
      accType: "",
      ifscCode: "",
      profession: "",
    },
  });

  const allValues = watch();
  const professionVal = watch("profession")

  useEffect(() => {
    const { accountNum, reAccountNum, accType, ifscCode, profession } = allValues;

    if (
      accountNum?.trim() &&
      reAccountNum?.trim() &&
      accType?.trim() &&
      ifscCode?.trim() &&
      profession
    ) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  }, [allValues]);

  const initFacebookPixel = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    } else {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      // Replace with your actual Facebook Pixel ID
      window.fbq('init', '2462375333984919');
      window.fbq('track', 'Lead');
    }
  };

  const getSignupPartnerDetail = async () => {
    try {
      const getValues = await axios.get(
        Partner_Portal.CreatePartner_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const signupResp = decryptData(getValues?.data);
      const decryptedData = JSON.parse(signupResp);
      if (decryptedData?.status === 0) {
        let partnerVal = decryptedData?.data?.info;
        setPartnerData(partnerVal)

        if(partnerVal?.isDigilocker === true){
          setDigilockerStatus(true)
        }else{
          setDigilockerStatus(false)
        }
        console.log(partnerVal, "partnerDataBank");

        if (partnerVal?.bankAcNumber?.length > 0) {
          setImpsValue(partnerVal?.impsValidated)
          if (partnerVal?.impsValidated === false && showBankData === "true") {
            setImpsSuccess(false);
            setShowBankDetails(true);
          }
          else {
            setImpsSuccess(true)
            setShowBankDetails(false);
          }
        } else {
          setShowBankDetails(true);
        }

        // if (partnerData?.email === null) {
        //   toast.error("Your Previous details are pending. Please complete");
        //   navigate("/partner/basic-details");
        // }
        // else if ((partnerData?.pan === null || partnerData?.dob === null || partnerData?.nameOnPan === null ||
        //   partnerData?.aadharNumber === null || partnerData?.address === null ||
        //   partnerData?.address2 == null || partnerData?.pincode === null ||
        //   partnerData?.state === null || partnerData?.city === null) && partnerData?.isDigilocker === false
        // ) {
        //   toast.error("Your Previous details are pending. Please complete");
        //   navigate("/partner/document-upload");
        // }

        if (partnerVal?.bankAcNumber !== null) {
          setValue("accountNum", partnerVal?.bankAcNumber)
          setValue("reAccountNum", partnerVal?.bankAcNumber)
        }
        if (partnerVal?.bankAcType !== null) {
          setValue("accType", partnerVal?.bankAcType.toLowerCase())
        }
        if (partnerVal?.ifscCode !== null) {
          setValue("ifscCode", partnerVal?.ifscCode)
        }
        if (partnerVal?.profession !== null) {
          setValue("profession", partnerVal?.profession)
        }

        setInitialBankData({
          accountNum: partnerVal?.bankAcNumber || "",
          reAccountNum: partnerVal?.bankAcNumber || "",
          accType: partnerVal?.bankAcType || "",
          ifscCode: partnerVal?.ifscCode || "",
          profession: partnerVal?.profession || "",
        });
        // trigger();
      } else if (decryptedData?.data?.status === 1) {
        toast.error(decryptedData?.data?.message);
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  useEffect(() => {
    getSignupPartnerDetail();
  }, []);

  const getBankName = (item) => {
    let bankResp = document.querySelector("#input1").value;
    setBankName(bankResp);
    getBankIfscData(item, null);
    setBankError("");
    setBranchName("");
    setBranchIfscData("");
  };

  const getBranchName = (branch) => {
    let branchResp = document.querySelector("#input2").value;
    setBranchName(branchResp);
    getBankIfscData(bankName, branch);
    setBranchError("");
  };

  const onSubmit = (data) => {
    initFacebookPixel();
    updatePartnerBankDetails(data);
  };

  const handleModalSubmit = (e) => {
    e.preventDefault();
    if (
      (selectBank?.length > 0 && selectBranch?.length > 0) ||
      (bankName?.length > 0 && branchName?.length > 0)
    ) {
      setModalShow(false);
    } else if (
      selectBank?.length == 0 &&
      bankName?.length == 0 &&
      selectBranch?.length == 0 &&
      branchName?.length == 0
    ) {
      setBankError("Select Bank");
      setBranchError("Select Branch");
    } else if (selectBank?.length == 0 && bankName?.length == 0) {
      setBankError("Select Bank");
    } else if (selectBranch?.length == 0 && branchName?.length == 0) {
      setBranchError("Select Branch");
    }
  };

  const selectBankOpt = (e) => {
    setBankName(e?.target?.value?.toUpperCase());
    setBranchName("");
    setSelectBank(e?.target?.value?.toUpperCase());
    setBankError("");
  };

  const selectBranchOpt = (e) => {
    setBranchName(e?.target?.value?.toUpperCase());
    setSelectBranch(e?.target?.value?.toUpperCase());
    setBranchError("");
  };

  const updatePartnerBankDetails = async (data) => {
    console.log(data, "bankdetails");

    setBankLoader(true);
    let encryptedPayload = {
      bankAcNumber: data?.accountNum,
      bankAcType: data?.accType,
      profession: parseInt(data?.profession),
      ifscCode: data?.ifscCode || getValues("ifscCode"),
    };
    console.log(encryptedPayload, "encryptedPayload");

    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const getValue = await axios.put(
        Partner_Portal.CreatePartner_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const getBankData = decryptData(getValue?.data);
      const decryptedBankData = JSON.parse(getBankData);
      if (decryptedBankData?.status === 0) {
        const currentValues = getValues();

        const hasChanged =
          initialBankData?.accountNum !== currentValues?.accountNum ||
          initialBankData?.accType !== currentValues?.accType ||
          initialBankData?.ifscCode !== currentValues?.ifscCode ||
          initialBankData?.profession !== currentValues?.profession;

        if (impsSuccess && !hasChanged) {
          navigate("/partner/document-upload");
        } else {
          getImpsValidationDetails();
        }
      } else {
        toast.error(decryptedBankData?.message);
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setBankLoader(false);
    }
  };

  const getBankIfscData = async (bank, branch) => {
    let encryptedPayload = {
      bank: bank ? bank : "",
      branch: branch ? branch : "",
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

    try {
      const getIfsc = await axios.post(
        Partner_Portal.GetBankIfsc_Url,
        encPayloadVal
      );
      const getBankIfsc = decryptData(getIfsc?.data);
      const decryptIfsc = JSON.parse(getBankIfsc);
      if (decryptIfsc?.status === 0) {
        const response = decryptIfsc?.data?.info;
        if (response?.banks !== null) {
          setBankDataList(response?.banks);
          setBankList(response?.banks);
        }
        if (bank?.length > 0 && response?.branches !== null) {
          setBranchIfscData(response?.branches);
          setBranchList(response?.branches);
        } else if (
          bank?.length > 0 &&
          response?.branches == null
        ) {
          // setBranchData(response?.branches);
        }
        if (
          bank?.length > 0 &&
          branch?.length > 0 &&
          response?.ifsc !== ""
        ) {
          setValue("ifscCode", response?.ifsc);
        }
      } else if (decryptIfsc?.status === 1) {
        toast.error(decryptIfsc?.message);
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  const handleClickIfsc = () => {
    setBankName("");
    setBranchName("");
    setModalShow(true);
    getBankIfscData(null, null);
  };

  const showBankName = () => {
    setBankShow(true);
  };
  const showBranchName = () => {
    setBranchShow(true);
  };

  const handleCloseModal = () => {
    setBankError("");
    setBranchError("");
    setModalShow(false);
    setBankName("");
    setBranchName("");
    setBankShow(false);
    setBranchShow(false);
    // setIfsc("");
  };

  const getImpsValidationDetails = async () => {
    setImpsLoader(true);
    let encryptedPayload = {
      ifsc_code: getValues("ifscCode"),
      account_number: getValues("accountNum"),
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

    try {
      const getValue = await axios.post(
        Partner_Portal.GetImpsValidation_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const getImpsData = decryptData(getValue?.data);
      const decryptedImps = JSON.parse(getImpsData);
      console.log(decryptedImps, "decryptedImps");

      if (decryptedImps?.status === 0) {
        toast.success(decryptedImps?.data?.message);
        navigate("/partner/selfie-upload");
      } else if (decryptedImps?.status === 1) {
        toast.error(decryptedImps?.message);
        setImpsSuccess(true)
        localStorage.removeItem("showBankData")
        setShowBankDetails(false);
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setImpsLoader(false);
    }
  };

  const deleteDocuments = async (data) => {
    let encryptedPayload = {
      fileType: data,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));

    try {
      const getDeleteData = await axios.delete(
        Partner_Portal.GetDocumentsList_Url,

        {
          data: encPayloadVal,
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const deletedResp = decryptData(getDeleteData?.data);
      const decryptedDeleteResp = JSON.parse(deletedResp);
      if (decryptedDeleteResp?.status === 0) {
        console.log("Cancel cheque deleted");

      } else {
        console.log("Cancel cheque not deleted");
      }
    } catch (error) {
      console.log(error);
      if(error?.response?.status === 500){
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if(error?.request?.status === 401){
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  useEffect(() => {
    if (impsValue === true) {
      deleteDocuments("4");
    }
  }, [impsValue])

  useEffect(() => {
    if (selectBank) {
      const filterArr =
        bankList?.length &&
        bankList?.filter((bankVal) =>
          bankVal?.bName?.toUpperCase().includes(selectBank?.toUpperCase())
        );
      filterArr?.length ? setBankDataList(filterArr) : setBankDataList([]);
    } else {
      setBankDataList(bankList);
    }
  }, [selectBank]);

  useEffect(() => {
    if (selectBranch) {
      const filterBranchArr =
        branchList?.length &&
        branchList?.filter((branchVal) =>
          branchVal?.toUpperCase().includes(selectBranch?.toUpperCase())
        );
      filterBranchArr?.length
        ? setBranchIfscData(filterBranchArr)
        : setBranchIfscData([]);
    } else {
      setBranchIfscData(branchList);
    }
  }, [selectBranch]);

  const previousBtn = () => {
    if(digilockerStatus === false){
    localStorage.setItem("addressSection", true)
    }
    navigate("/partner/document-upload");
  };

  const getAccountNumber = (e, type) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 18);
    if (type === "account") {
      setValue("accountNum", digitsOnly)
      trigger("reAccountNum")
    } else {
      setValue("reAccountNum", digitsOnly)
    }
  };

  const handleBankNum = (e, type) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    const digitsOnly = pasteData.replace(/\D/g, "").slice(0, 18);

    if (digitsOnly?.length > 0) {
      if (type === "account") {
        setValue("accountNum", digitsOnly)
        trigger("accountNum");
      } else if (type === "confirm") {
        const accountNum = getValues("accountNum");
        setValue("reAccountNum", digitsOnly)
        trigger("reAccountNum");

        if (accountNum && digitsOnly !== accountNum) {
          setError("reAccountNum", {
            type: "manual",
            message: "Bank account numbers must match",
          });
        } else {
          clearErrors("reAccountNum");
        }
      }
    }
  };

  const handlePasteIFSC = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData
      .getData("text")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 11);
    const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (ifscPattern.test(pastedText)) {
      setValue("ifscCode", pastedText, { shouldValidate: true });
      clearErrors("ifscCode");
      trigger("ifscCode");
    } else {
      setError("ifscCode", {
        type: "manual",
        message: "IFSC Code is required",
      });
    }

  };
  console.log(impsSuccess, showBankDetails, showBankData, "impsSuccess0000");


  return (
    <>
      <HeaderPartner />
      <PageProgressBarPartner progress="bank-details" partnerData={partnerData}/>

      <main className="main-content page-wrapper partner-page partner-page-postlogin">
        <div className="h-md-100">
          <Row className="h-md-100 p-0 m-0 mobile-view">
            <Col lg={6} className="p-0">
              <PageSideBar />
            </Col>
            <Col lg={6} className="p-0">
              {(showBankDetails || showBankData === "true") &&
                <div className="page-header right-box">
                  <div className="wrap-all scroll-form">

                    <div className="page-left landing-page viewheight">
                      <img
                        className="previous-btn"
                        src={previosPageArrow}
                        alt="previous page btn"
                        onClick={previousBtn}
                      />
                      <div>
                        <h2 className="page-title">
                          Add your bank for timely payouts
                        </h2>
                        <h3 className="page-subtitle partner-subtitle">
                          All your payouts will be credited in this bank account
                        </h3>
                      </div>
                    </div>
                    <form
                      className="page-form landing-form partner-bank"
                      autoComplete="off"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="bank-detail-content">
                        <div className="mb-3">
                          <label className="text-label">
                            Bank Account Number
                            <span class="mandatory-label">*</span>
                          </label>

                          <div className="form-group pan-input custom-suggest error-wrap address-input">
                            <input
                              maxLength={18}
                              type="password"
                              placeholder="Enter bank account number"
                              pattern="[0-9]*"
                              className="mt-2 form-control is-invalid address-field"
                              {...register("accountNum")}
                              onInput={(e) => getAccountNumber(e, "account")}
                              autoComplete="new-password"
                              onPaste={(e) => handleBankNum(e, "account")}
                            />

                            <p className="forget-link add-error bank-err">
                              <span>{errors.accountNum?.message}</span>
                            </p>
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="text-label">
                            Confirm Bank Account Number
                            <span class="mandatory-label">*</span>
                          </label>
                          <div className="form-group pan-input custom-suggest error-wrap address-input">
                            <input
                              maxLength={18}
                              pattern="[0-9]*"
                              type="text"
                              placeholder="Re-enter bank account number"
                              className="mt-2 form-control has-value is-invalid address-field"
                              {...register("reAccountNum")}
                              onInput={(e) => getAccountNumber(e, "confirm")}
                              autoComplete="new-password"
                              onPaste={(e) => handleBankNum(e, "confirm")}
                            />
                            <p className="forget-link add-error bank-err">
                              <span>{errors.reAccountNum?.message}</span>
                            </p>
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="text-label">
                            Sector
                            <span class="mandatory-label">*</span>
                          </label>
                          <div className="form-group partner-form-group error-wrap address-input">
                            <select
                              type="text"
                              className="mt-2 form-control has-value is-invalid datepicker"
                              autoComplete="new-password"
                              placeholder="Select Sector"
                              {...register("profession")}
                            >
                              <option value="">Select Sector</option>
                              {professionList &&
                                professionList.map((item) => {
                                  return (
                                    <option value={item?.ID}>
                                      {item?.Profession}
                                    </option>
                                  );
                                })}
                            </select>

                            <p className="forget-link add-error">
                              <span>{errors.profession?.message}</span>
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="text-label">
                              IFSC Code
                              <span class="mandatory-label">*</span>
                            </label>
                            <div className="form-group partner-form-group bank-ifsc error-wrap address-input">
                              <input
                                onPaste={handlePasteIFSC}
                                maxLength={11}
                                type="text"
                                placeholder="Enter IFSC code"
                                className="mt-2 form-control has-value text-uppercase is-invalid address-field"
                                autoComplete="off"
                                onKeyPress={validateIFSC}
                                {...register("ifscCode")}
                                onChange={(e) => {
                                  const start = e.target.selectionStart;
                                  const end = e.target.selectionEnd;

                                  let input = e.target.value;
                                  input = input
                                    .toUpperCase()
                                    .replace(/[^A-Z0-9]/g, "")
                                    .replace(/\s+/g, " ")
                                    // .trimStart()
                                    .slice(0, 11);

                                  e.target.value = input;

                                  e.target.setSelectionRange(start, end);
                                }}

                                defaultValue={getValues("ifscCode")}
                              ></input>
                              <p className="forget-link add-error bank-err ifsc-error">
                                <span>{errors.ifscCode?.message}</span>
                              </p>
                            </div>
                          </div>

                          <div className="col-md-6 mb-3 acc-type-wrapper">
                            <label className="text-label">
                              Account Type
                              <span class="mandatory-label">*</span>
                            </label>

                            <div className="form-group pan-input custom-suggest">
                              <div className="form-group partner-form-group error-wrap address-input">
                                <select
                                  type="text"
                                  className="mt-2 form-control has-value datepicker is-invalid address-field"
                                  autoComplete="off"
                                  {...register("accType")}
                                >
                                  <option value="" selected>
                                    Select Account Type
                                  </option>
                                  <option value="current" className="opt">
                                    Current
                                  </option>
                                  <option value="saving" className="opt">
                                    Saving
                                  </option>
                                </select>

                                <p className="forget-link add-error bank-err">
                                  <span>{errors.accType?.message}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 search-ifsc">
                          <Link
                            type="submit"
                            className=""
                          // onClick={()=> showResponse()}
                          >
                            <span className="icon-search-bar"></span>
                            {/* <img src={searchIcon} alt="search icon" /> */}
                            <span
                              className="search-text"
                              onClick={() => handleClickIfsc()}
                            >
                              Find IFSC
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div className="button-submit">

                        <button
                          type="submit"
                          className={`${!isButtonEnabled ? "partner-loginBtn next-btn disable-esign-btn" : "partner-loginBtn next-btn"}`}
                          disabled={!isButtonEnabled}
                        >
                          {bankLoader ? (
                            <SmallLoader />
                          ) : impsLoader ? (
                            <SmallLoader />
                          ) : (
                            <>Next</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className="wrap-footerData">
                    <div className="bank-detail-secure">
                      <img
                        src={sheild}
                        alt=""
                        className="bank-detail-secure-img"
                      />
                      <p className="bank-detail-secure-txt">
                        Your information is safe and secure with us
                      </p>
                    </div>
                    <FormFooterPartner />
                  </div>
                </div>
              }

              {(impsSuccess && showBankData !== "true") &&
                <DigiDocumentList
                  impsSuccess={impsSuccess}
                  setImpsSuccess={setImpsSuccess}
                  setShowBankDetails={setShowBankDetails}
                  showBankDetails={showBankDetails} />}
            </Col>
          </Row>
        </div>
      </main>

      <Modal
        show={modalShow}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="ifscModal partner-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="figure-inlac">
              <div className="model-title">Find Your IFSC Code</div>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => handleCloseModal()}
          // onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="ifsc-form select-new modal-select">
            <div className="form-group address-input">
              <label htmlFor="bank-text">Select Bank</label>

              <div className="rm-custom-dropdown bankName-input">
                <input
                  className="address-field"
                  type="text"
                  name="search-text"
                  id="input1"
                  placeholder="Bank"
                  autoComplete="off"
                  onChange={(e) => selectBankOpt(e)}
                  value={bankName ? bankName : ""}
                  onClick={() => showBankName()}
                />
                <span
                  className="icon-right-arrow-triangle"
                  onClick={() => setBankShow(!bankShow)}
                ></span>

                {bankShow && (
                  <>
                    <ul className="rm-mapping-ap bank-names">
                      {bankDataList &&
                        bankDataList.map((item, i) => (
                          <li
                            key={i}
                            className="rm-maping-item-wrapper"
                            onClick={() => {
                              setBankShow(false);
                              document.querySelector("#input1").value =
                                item?.bName;
                              getBankName(item?.bName);
                            }}
                          >
                            <div>{item?.bName}</div>
                          </li>
                        ))}
                    </ul>
                  </>
                )}
              </div>
              {bankDataList?.length == 0 || selectBank?.length == 0 ? (
                <p className="forget-link ifsc-modal-err">
                  <span>{bankError}</span>
                </p>
              ) : (
                ""
              )}
            </div>

            <div className="form-group address-input">
              <label htmlFor="bank">Select Branch</label>
              <div className="rm-custom-dropdown bankName-input">
                <input
                  className="address-field"
                  type="text"
                  name="search-text"
                  id="input2"
                  placeholder="Branch"
                  autoComplete="off"
                  onChange={(e) => selectBranchOpt(e)}
                  value={branchName ? branchName : ""}
                  onClick={() => showBranchName()}
                />
                <span
                  className="icon-right-arrow-triangle"
                  onClick={() => setBranchShow(!branchShow)}
                ></span>
                {branchShow && (
                  <>
                    <ul className="rm-mapping-ap bank-names">
                      {
                        // branchData !== null ?
                        branchIfscData &&
                        branchIfscData.map((branchVal, i) => (
                          <li
                            key={i}
                            className="rm-maping-item-wrapper"
                            onClick={() => {
                              setBranchShow(false);
                              document.querySelector("#input2").value =
                                branchVal;
                              getBranchName(branchVal);
                            }}
                          >
                            <div>{branchVal}</div>
                          </li>
                        ))
                        // : <li className="rm-maping-item-wrapper">
                        //       <div>No Branch available</div>
                        // </li>
                      }
                    </ul>
                  </>
                )}
              </div>
              {branchIfscData?.length == 0 || selectBranch?.length == 0 ? (
                <p className="forget-link">
                  <span>{branchError}</span>
                </p>
              ) : (
                ""
              )}
            </div>
          </form>

          <div className="text-center partner-button">
            <button
              className="common-btn get-detail-btn"
              type="submit"
              onClick={handleModalSubmit}
            >
              GET DETAILS
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default BankDetailsPartner;
